import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import useConfig from 'hooks/useConfig';
import {
    useGetApiUserPreferencesParsedQuery,
    usePutApiUserPreferencesMutation,
} from 'store/userOrg/enhancedUserOrgApi';
import { PresetColor } from 'types/config';

const ThemeSelection = () => {
    const { data: preferences } = useGetApiUserPreferencesParsedQuery();
    const [putPreferences] = usePutApiUserPreferencesMutation();
    const { presetColor, onChangePresetColor } = useConfig();

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newPresetColor = event.target.value as typeof presetColor;

        onChangePresetColor(newPresetColor);

        putPreferences({
            body: {
                ...preferences,
                presetColor: newPresetColor,
            },
        });
    };

    return (
        <FormControl>
            <FormLabel>Theme</FormLabel>
            <RadioGroup value={presetColor} onChange={handleRadioChange}>
                <Grid container>
                    <Grid item xs={6}>
                        <FormControlLabel value={PresetColor.DEFAULT} control={<Radio />} label='Default' />
                        <FormControlLabel value={PresetColor.THEME1} control={<Radio />} label='Theme1' />
                        <FormControlLabel value={PresetColor.THEME2} control={<Radio />} label='Theme2' />
                        <FormControlLabel value={PresetColor.THEME3} control={<Radio />} label='Theme3' />
                        <FormControlLabel value={PresetColor.THEME4} control={<Radio />} label='Theme4' />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel value={PresetColor.THEME5} control={<Radio />} label='Theme5' />
                        <FormControlLabel value={PresetColor.THEME6} control={<Radio />} label='Theme6' />
                        <FormControlLabel value={PresetColor.THEME7} control={<Radio />} label='Theme7' />
                        <FormControlLabel value={PresetColor.THEME8} control={<Radio />} label='Theme8' />
                        <FormControlLabel
                            value={PresetColor.EFP}
                            control={<Radio />}
                            label={PresetColor.EFP.toUpperCase()}
                        />
                    </Grid>
                </Grid>
            </RadioGroup>
        </FormControl>
    );
};

export default ThemeSelection;
